import React from "react";
import AppImg1 from "../Assets/img/get-app/get-app-1.png";
import AppImg2 from "../Assets/img/get-app/get-app-2.png";
import AppImg3 from "../Assets/img/get-app/get-app-3.png";
import AppImg4 from "../Assets/img/get-app/get-app-4.png";
import AppImg5 from "../Assets/img/get-app/get-app-5.png";
import AppImg6 from "../Assets/img/get-app/get-app-6.png";
import AndroidAppImg from "../Assets/img/android-app.png";

const GetAppMain = [
  {
    id: "app1",
    icon: AppImg1,
    title: "Easy to use",
  },
  {
    id: "app2",
    icon: AppImg2,
    title: "User friendly interface",
  },
  {
    id: "app3",
    icon: AppImg3,
    title: "Easily manage",
  },
  {
    id: "app4",
    icon: AppImg4,
    title: "User statistics",
  },
  {
    id: "app5",
    icon: AppImg5,
    title: "Invoice generate",
  },
  {
    id: "app6",
    icon: AppImg6,
    title: "Payment getwaye",
  },
];

const GetApp = () => {
  return (
    <>
      <section className="get-app-area">
        <div className="container">
          <div className="row">
            <div className="col-lg-5 col-md-6 col-12">
              <div className="get-app-title">
                <h3 className="get-title">
                  Get the android app with awesome features
                </h3>
                <p>
                  ISP Digital has an android application for the management of
                  clients. User can easily handle their account via the app.
                </p>
              </div>
              <div className="single-get-app-inner">
                <div className="row">
                  {GetAppMain.map((singleCard) => (
                    <div
                      className="col-lg-4 col-md-4 col-12"
                      key={singleCard.id}
                    >
                      <div className="single-get-app">
                        <img src={singleCard.icon} alt="#" />
                        <h4>{singleCard.title}</h4>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
            <div className="col-lg-6 offset-lg-1 col-md-6 offset-md-0 col-12  order-top">
              <div className="get-app-image">
                <img src={AndroidAppImg} alt="#" />
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default GetApp;
